.base-size {
  --alert-icon-size: var(--sizes-md);
  --alert-spacing: var(--sizes-base);
  --alert-close-padding: none;
  --alert-close-justify: start;
  --alert-right-action-spacing: var(--sizes-3);
}

.sm-size {
  --alert-icon-size: var(--sizes-5);
  --alert-spacing: var(--sizes-3);
  --alert-close-padding: none;
  --alert-close-justify: start;
  --alert-right-action-spacing: var(--sizes-3);
}

.xs-size {
  --alert-icon-size: var(--sizes-5);
  --alert-spacing: var(--sizes-sm);
  --alert-close-padding: var(--sizes-xs);
  --alert-close-justify: center;
  --alert-right-action-spacing: none;
}

.iconTextContainer {
  gap: var(--alert-spacing);
  margin: var(--alert-spacing);
}

.closeContainer {
  height: 100%;
  padding: var(--alert-close-padding);
  justify-content: var(--alert-close-justify);
}

.rightActionsContainer {
  gap: var(--alert-right-action-spacing);
  margin: var(--alert-right-action-spacing);
}

.rightActions {
  gap: var(--alert-spacing);
}

.alertContainer {
  border: 1px solid var(--primary-color, var(--colors-neutral-ink-base));
  border-radius: var(--radius-base);
  background-color: var(--background-color, var(--colors-neutral-grey-lightest));
  gap: 0;
}
